import { render, staticRenderFns } from "./InfiniteBiScroll.vue?vue&type=template&id=08ebfdf2&scoped=true"
import script from "./InfiniteBiScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfiniteBiScroll.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InfiniteBiScroll.vue?vue&type=style&index=0&id=08ebfdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ebfdf2",
  null
  
)

export default component.exports